module.exports = "<template> <span if.bind=participant.sumItemsPrice>${ participant.sumItemsPrice | currency }</span> </template> ";